import { render, staticRenderFns } from "./header-atis.vue?vue&type=template&id=ba66744e&"
import script from "./header-atis.vue?vue&type=script&lang=js&"
export * from "./header-atis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports